import React from 'react'
import './index.scss'
import clsx from 'clsx'
interface GroupedPublishersFooterProps {
    totalShares: number
}

const GroupedPublishersFooter = (props: GroupedPublishersFooterProps) => {
    const { totalShares } = props
    return (
        <div className="grouped-publishers-footer">
            <p>Total Submitted Shares</p>
            <p className={clsx(totalShares <= 100.06 ? 'green' : 'red')}>{totalShares.toFixed(2) + '%'}</p>
        </div>
    )
}

export default GroupedPublishersFooter
